import {Component, ViewChild, ViewEncapsulation} from '@angular/core';
import {MatTab, MatTabContent, MatTabGroup, MatTabLabel} from '@angular/material/tabs';
import {AlternativePayerTableComponent} from './alternative-payer-table.component';
import {MatIcon} from '@angular/material/icon';
import {AuthorizeVisibilityDirective, EsvgFiles} from 'frontier';
import {DataofficeTableComponent} from "./dataoffice-table.component";
import {PayerHiddenTableComponent} from "./payer-hidden-table.component";
import {AUTHORIZATION_CONFIG} from '../../../config/authorization.config';
import {TabActivatedDirective} from "frontier/browserkit/src/lib/directives/tab-activated.directive";

@Component({
  selector: 'app-payer-overview',
  templateUrl: './payer-overview.component.html',
  styleUrl: './payer-overview.component.scss',
  standalone: true,
  imports: [
    MatTab,
    MatTabContent,
    MatTabGroup,
    MatTabLabel,
    PayerHiddenTableComponent,
    AlternativePayerTableComponent,
    MatIcon,
    DataofficeTableComponent,
    AuthorizeVisibilityDirective,
    TabActivatedDirective,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class PayerOverviewComponent {
  protected readonly EsvgFiles = EsvgFiles;
  protected readonly AUTHORIZATION_CONFIG = AUTHORIZATION_CONFIG;
}
